import React, { useState } from 'react'
import {
  Button,
  FormInputSelect,
  FormInput,
  Col,
  Row,
  FormInputDate,
  FormInputTextArea,
  FormInputText
} from 'camino-react'
import _ from 'lodash'
import moment from 'moment-timezone'

import Status from './BulkUpdateAttributes/Status'
import Queue from './BulkUpdateAttributes/Queue'
import Assignee from './BulkUpdateAttributes/Assingee'
import Category from './BulkUpdateAttributes/Category'
import Client from './BulkUpdateAttributes/Client'
import Priority from './BulkUpdateAttributes/Priority'
import Type from './BulkUpdateAttributes/Type'

const AssociatedItemsSelectors = ({
  editedItems,
  options,
  addEditedItem,
  optionValues,
  onHoldValues,
  resolvedStatusesId,
  queuesAssignees,
  selectedOptions,
  setRegionToUpdate,
  getCategoryServiceByRegion,
  setErrorRegionClient,
  regionToUpdate,
  showOnHoldOrResolved,
  priorities,
  ticketTypes
}) => {
  const [queueDisabled, setQueueDisabled] = useState(false)
  const [assigneeDisabled, setAssigneeDisabled] = useState(false)
  const [valueDisabledQueue, setValueDisabledQueue] = useState()
  const [valueOfDisabledAssigneeQueues, setValueOfDisabledAssigneeQueues] = useState()
  const [isTicketStatusResolved, setIsTicketStatusResolved] = useState(false)
  const [isTicketStatusOnHold, setIsTicketStatusOnHold] = useState(false)

  const resetAssigneeToDefault = () => {
    _.map(editedItems, (editedItem) => {
      if (editedItem.firstValueId === 'assignee') {
        editedItem.updateOptionValue('assigneeId', '')
      }
    })
  }

  const resetQueueToDefault = () => {
    _.map(editedItems, (editedItem) => {
      if (editedItem.firstValueId === 'queue') {
        editedItem.updateOptionValue('queueId', '')
      }
    })
  }
  const resetStateCategoryToDefault = () => {
    _.map(editedItems, (editedItem) => {
      if (editedItem.firstValueId === 'status') {
        editedItem.updateOptionValue('statusId', '')
      } else if (editedItem.firstValueId === 'category') {
        editedItem.updateOptionValue('categoryId', '')
        editedItem.updateOptionValue('subCategoryId', '')
      }
    })
  }

  const checkIfAttributesShouldBeFrozen = (firstColumnValue) => {
    if (firstColumnValue === 'queue' && (!_.includes(selectedOptions, 'assignee') && _.includes(selectedOptions, undefined))) {
      setAssigneeDisabled(true)
    } else if (firstColumnValue === 'assignee' && !_.includes(selectedOptions, 'queue') && _.includes(selectedOptions, undefined)) {
      setQueueDisabled(true)
    } else if (firstColumnValue === 'assignee' && _.includes(selectedOptions, 'queue') && !_.includes(selectedOptions, undefined)) {
      setQueueDisabled(true)
      setAssigneeDisabled(false)
      setValueDisabledQueue(null)
    } else if (firstColumnValue === 'queue' && _.includes(selectedOptions, 'assignee') && !_.includes(selectedOptions, undefined)) {
      setQueueDisabled(false)
      setAssigneeDisabled(true)
      setValueOfDisabledAssigneeQueues(null)
    }
  }

  const showTicketOnHold = (firstColumnValue) => {
    return isTicketStatusOnHold && firstColumnValue === 'status' && showOnHoldOrResolved
  }

  const showTicketResolved = (firstColumnValue) => {
    return isTicketStatusResolved && firstColumnValue === 'status' && showOnHoldOrResolved
  }

  const twoOrMoreItems = editedItems.length > 1
  const editedItemsLength = editedItems.length
  return (
    <div>
      {_.map(editedItems, (editedItem, index) => (
        <div key={index}>
          <Row classExtra="row--bottom-spaced thin-gutters flex--centered">
            <Col width={9}>
              <FormInput>
                <div key={editedItem.id}>
                  <div>
                    <FormInputSelect
                      value={_.find(options, ({ value: editedItem.firstValueId }))}
                      options={_.filter(options, ({ disabled }) => (!disabled))}
                      isLoading={_.isEmpty(options)}
                      onValue={(value) => {
                        editedItem.updateOptionValue('firstValueId', value)
                        checkIfAttributesShouldBeFrozen(value)
                      }}
                      clearable
                    />
                  </div>
                </div>
              </FormInput>
            </Col>
            <Col width={9}>
              {editedItem.firstValueId === 'status' && (
                <Status
                  editedItem={editedItem}
                  statuses={optionValues[editedItem.firstValueId]}
                  onHoldStatuses={onHoldValues}
                  resolvedStatuses={resolvedStatusesId}
                  setIsTicketStatusResolved={setIsTicketStatusResolved}
                  setIsTicketStatusOnHold={setIsTicketStatusOnHold}
                />
              )}
              {editedItem.firstValueId === 'queue' && (
                <Queue
                  editedItem={editedItem}
                  queues={optionValues[editedItem.firstValueId]}
                  queueDisabled={queueDisabled}
                  valueDisabledQueue={valueDisabledQueue}
                  setValueOfDisabledAssigneeQueues={setValueOfDisabledAssigneeQueues}
                  resetAssigneeToDefault={resetAssigneeToDefault}
                />
              )}
              {editedItem.firstValueId === 'client' && (
                <Client
                  editedItem={editedItem}
                  clients={optionValues[editedItem.firstValueId]}
                  setRegionToUpdate={setRegionToUpdate}
                  getCategoryServiceByRegion={getCategoryServiceByRegion}
                  setErrorRegionClient={setErrorRegionClient}
                  regionToUpdate={regionToUpdate}
                  resetStateCategoryToDefault={resetStateCategoryToDefault}
                />
              )}
              {editedItem.firstValueId === 'assignee' && (
                <Assignee
                  editedItem={editedItem}
                  assignees={optionValues[editedItem.firstValueId]}
                  queuesAssignees={queuesAssignees}
                  assigneeQueueDisabled={assigneeDisabled}
                  setValueDisabledQueue={setValueDisabledQueue}
                  valueOfDisabledAssigneeQueues={valueOfDisabledAssigneeQueues}
                  resetQueueToDefault={resetQueueToDefault}
                />
              )}
              {editedItem.firstValueId === 'category' && (
                <Category
                  editedItem={editedItem}
                  categories={optionValues[editedItem.firstValueId]}
                />
              )}
              {editedItem.firstValueId === 'priority' && (
                <Priority
                  editedItem={editedItem}
                  priorities={priorities}
                />
              )}
              {editedItem.firstValueId === 'ticket_type' && (
                <Type
                  editedItem={editedItem}
                  ticketTypes={ticketTypes}
                />
              )}
            </Col>
            {twoOrMoreItems && (
              <button
                type='button'
                style={{ border: 'none', background: 'transparent', outline: 'none' }}
                className="lnr lnr-trash2 lnr--hover-blue"
                onClick={() => editedItem.remove()}
              />
            )}
          </Row>
          {showTicketResolved(editedItem.firstValueId) && (
            <Row classExtra="row--bottom-spaced thin-gutters flex--centered">
              <Col width={18} classExtra=" flex--centered">
                <label htmlFor="ticket_root_cause">
                  What was the root cause?
                </label>
                <FormInputText
                  id="ticket_root_cause"
                  value={editedItem.rootCause}
                  onValue={text => editedItem.updateOptionValue('rootCause', text)}
                />

                <label htmlFor="ticket_preventive_action">
                  What is the preventive action?
                </label>
                <FormInputText
                  id="ticket_preventive_action"
                  value={editedItem.preventAction}
                  onValue={text => editedItem.updateOptionValue('preventAction', text)}
                />

                <label htmlFor="ticket_corrective_action">
                  How did you correct the issue?
                </label>
                <FormInputText
                  id="ticket_corrective_action"
                  value={editedItem.correctiveAction}
                  onValue={text => editedItem.updateOptionValue('correctiveAction', text)}
                />
              </Col>
            </Row>
          )}
          {showTicketOnHold(editedItem.firstValueId) && (
            <Row classExtra="row--bottom-spaced thin-gutters flex--centered">
              <Col width={18} classExtra=" flex--centered">
                <label htmlFor="ticket_reopen_on">
                  When will this ticket re-open?
                  <FormInputDate
                    placeholder="OnHoldDate"
                    value={_.isNil(editedItem.onHoldDate) ? moment().format('YYYY-MM-DD') : editedItem.onHoldDate}
                    onValue={(date) => { editedItem.updateOptionValue('onHoldDate', date) }}
                    enableTime={false}
                    name="editedItem[onHoldDate]"
                    id="onHoldDate"
                  />
                </label>

                <label htmlFor="ticket_on_hold_description">
                  Why is this ticket being put on hold?
                  <FormInputTextArea
                    placeholder="On Hold Description"
                    value={editedItem.onHoldDescritpion}
                    onValue={(text) => { editedItem.updateOptionValue('onHoldDescritpion', text) }}
                    name="editedItem[description]"
                    id="onHoldDescritpion"
                  />
                </label>
              </Col>
            </Row>
          )}
        </div>
      ))}
      <br />
      {(editedItemsLength < 5) && (
        <Button
          onClick={() => { addEditedItem() }}
          size="compact"
          outline
        >
          <span className="lnr lnr-plus lnr-inline"/>
          Add Attribute
        </Button>
      )}
    </div>
  )
}
export default AssociatedItemsSelectors
